import apiClient from './apiClient';

const subsectionServices = {
    fetchSubsections: async (sectionId) => {
        try {
            const response = await apiClient.get(`/subsections.php?action=getSubsections&section_id=${sectionId}`);
            return response.data;
        } catch (error) {
            console.error('Errore nel recupero delle sottosezioni:', error);
            throw error;
        }
    },

    addSubsection: async (subsection) => {
        try {
            const response = await apiClient.post('/subsections.php?action=addSubsection', subsection);
            return response.data;
        } catch (error) {
            console.error('Errore nell\'aggiunta della sottosezione:', error);
            throw error;
        }
    },

    updateSubsection: async (id, subsection) => {
        try {
            const response = await apiClient.put(`/subsections.php?action=updateSubsection&id=${id}`, subsection);
            return response.data;
        } catch (error) {
            console.error('Errore nell\'aggiornamento della sottosezione:', error);
            throw error;
        }
    },

    removeSubsection: async (id) => {
        try {
            const response = await apiClient.delete(`/subsections.php?action=removeSubsection&id=${id}`);
            return response.data;
        } catch (error) {
            console.error('Errore nella rimozione della sottosezione:', error);
            throw error;
        }
    },
};

export default subsectionServices;
